<template>
    <div class="box has-no-glow-effect">
        <p class="mb-1 has-text-weight-bold">
            {{ translate("page.admin_coach_passes.limit_title") }}
        </p>

        <div>
            <span class="icon">
                <i class="fas fa-users"></i>
            </span>
            <span>{{ limitRuleText }}</span>
        </div>
        <div v-if="settings.passesPerBlock !== null">
            <span class="icon">
                <i v-if="settings.fillWithBlank && !settings.blankNames" class="fas fa-check-circle has-text-success" />
                <i v-else class="fas fa-times-circle has-text-danger" />
            </span>
            <span>{{ translate("page.admin_coach_passes.limit_fill_with_blank") }}</span>
        </div>
        <div>
            <span class="icon">
                <i v-if="settings.blankNames" class="fas fa-check-circle has-text-success" />
                <i v-else class="fas fa-times-circle has-text-danger" />
            </span>
            <span>{{ translate("page.admin_coach_passes.limit_blank_names") }}</span>
        </div>

        <button class="button is-small mt-3" @click="emit('changeOptions')">
            <span class="icon">
                <i class="fas fa-wrench"></i>
            </span>
            <span>{{ translate("admin_results.change_options") }}</span>
        </button>
    </div>
</template>

<script setup lang="ts">
    import { computed } from "vue";
    import { translate } from "../Common/translations";
    import { CoachPassSettings } from "../Api/coachPasses";

    const props = defineProps<{
        settings: CoachPassSettings;
    }>();

    const emit = defineEmits<{
        changeOptions: [];
    }>();

    const limitRuleText = computed(() =>
        props.settings.passesPerBlock !== null
            ? translate("page.admin_coach_passes.limit_active", false, [
                  props.settings.passesPerBlock,
                  props.settings.competitorsPerBlock ?? 0,
              ])
            : translate("page.admin_coach_passes.limit_none"),
    );
</script>
